/* script */































import Vue from 'vue';
import Component from 'vue-class-component';
import moment, { Moment } from 'moment';

@Component({
    name: 'guest-date-picker',
    props: ['value', 'default', 'placeholder', 'selectable-dates'],
})
class GuestDatePicker extends Vue {
    value!: string | null;
    default!: string | null;
    placeholder!: string | null;
    selectableDates!: string[] | null;

    private update(current: Moment) {
        this.$emit(
            'input',
            current.isValid() ? current.format('YYYY-MM-DD') : null
        );
    }

    getDefault() {
        if (!this.default) return null;
        return moment(this.default).toDate();
    }

    getDate() {
        if (!this.value) return null;
        return moment(this.value).toDate();
    }

    getYear() {
        if (!this.value) return null;
        return moment(this.value).format('YYYY');
    }
    setYear(year: string) {
        const current = moment(this.value || this.default || undefined);
        current.set('year', parseInt(year));
        this.update(current);
    }
    yearList() {
        if (this.selectableDates) {
            const years = this.selectableDates.map((date) =>
                moment(date).year()
            );
            return [...new Set(years)];
        }
        const list = [];
        const thisYear = moment().get('year');
        for (let y = thisYear; y > thisYear - 120; y--) {
            list.push(y);
        }
        return list;
    }

    getMonth() {
        if (!this.value) return null;
        return moment(this.value).format('MM');
    }
    setMonth(month: string) {
        const current = moment(this.value || this.default || undefined);
        current.set('month', parseInt(month) - 1);
        this.update(current);
    }
    monthList() {
        if (this.selectableDates && this.value) {
            const year = moment(this.value).year();
            const monthes = this.selectableDates
                .map((date) => moment(date))
                .filter((m) => m.year() == year)
                .map((m) => m.month() + 1);
            return [...new Set(monthes)].map((m) => ('0' + m).slice(-2));
        }

        const list = [];
        for (let m = 1; m <= 12; m++) {
            list.push(('0' + m).slice(-2));
        }
        return list;
    }

    getDay() {
        if (!this.value) return null;
        return moment(this.value).format('DD');
    }
    setDay(day: string) {
        const current = moment(this.value || this.default || undefined);
        current.set('date', parseInt(day));
        this.update(current);
    }
    dayList() {
        if (this.selectableDates && this.value) {
            const year = moment(this.value).year();
            const month = moment(this.value).month();
            const days = this.selectableDates
                .map((date) => moment(date))
                .filter((m) => m.year() == year && m.month() == month)
                .map((m) => m.date());
            return [...new Set(days)].map((d) => ('0' + d).slice(-2));
        }

        const list = [];
        const lastDay = moment(this.value || this.default || undefined)
            .endOf('month')
            .get('date');
        for (let d = 1; d <= lastDay; d++) {
            list.push(('0' + d).slice(-2));
        }
        return list;
    }
}
const __vue_script__ = GuestDatePicker;

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "select",
      {
        domProps: { value: _vm.getYear() },
        on: {
          change: function ($event) {
            return _vm.setYear($event.target.value)
          },
        },
      },
      _vm._l(_vm.yearList(), function (t) {
        return _c("option", { key: t, domProps: { value: t } }, [
          _vm._v(_vm._s(t)),
        ])
      }),
      0
    ),
    _vm._v("\n    /\n    "),
    _c(
      "select",
      {
        domProps: { value: _vm.getMonth() },
        on: {
          change: function ($event) {
            return _vm.setMonth($event.target.value)
          },
        },
      },
      _vm._l(_vm.monthList(), function (t) {
        return _c("option", { key: t, domProps: { value: t } }, [
          _vm._v("\n            " + _vm._s(t) + "\n        "),
        ])
      }),
      0
    ),
    _vm._v("\n    /\n    "),
    _c(
      "select",
      {
        domProps: { value: _vm.getDay() },
        on: {
          change: function ($event) {
            return _vm.setDay($event.target.value)
          },
        },
      },
      _vm._l(_vm.dayList(), function (t) {
        return _c("option", { key: t, domProps: { value: t } }, [
          _vm._v(_vm._s(t)),
        ])
      }),
      0
    ),
  ])
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-0addfa45_0", { source: "div[data-v-0addfa45] {\n  display: flex;\n  justify-content: start;\n  align-items: center;\n}\ndiv select[data-v-0addfa45] {\n  cursor: pointer;\n  width: fit-content;\n  padding: 0 1.2em;\n}\n\n/*# sourceMappingURL=GuestDatePicker.vue.map */", map: {"version":3,"sources":["script_src/common/GuestDatePicker.vue","GuestDatePicker.vue"],"names":[],"mappings":"AACA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;ACAA;ADCA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;ACCA;;AAEA,8CAA8C","file":"GuestDatePicker.vue","sourcesContent":["<style lang=\"scss\" scoped>\ndiv {\n    display: flex;\n    justify-content: start;\n    align-items: center;\n    select {\n        cursor: pointer;\n        width: fit-content;\n        padding: 0 1.2em;\n    }\n}\n</style>\n<template>\n    <div>\n        <select :value=\"getYear()\" @change=\"setYear($event.target.value)\">\n            <option v-for=\"t in yearList()\" :value=\"t\" :key=\"t\">{{ t }}</option>\n        </select>\n        /\n        <select :value=\"getMonth()\" @change=\"setMonth($event.target.value)\">\n            <option v-for=\"t in monthList()\" :value=\"t\" :key=\"t\">\n                {{ t }}\n            </option>\n        </select>\n        /\n        <select :value=\"getDay()\" @change=\"setDay($event.target.value)\">\n            <option v-for=\"t in dayList()\" :value=\"t\" :key=\"t\">{{ t }}</option>\n        </select>\n    </div>\n</template>\n\n<script lang=\"ts\">\nimport Vue from 'vue';\nimport Component from 'vue-class-component';\nimport moment, { Moment } from 'moment';\n\n@Component({\n    name: 'guest-date-picker',\n    props: ['value', 'default', 'placeholder', 'selectable-dates'],\n})\nclass GuestDatePicker extends Vue {\n    value!: string | null;\n    default!: string | null;\n    placeholder!: string | null;\n    selectableDates!: string[] | null;\n\n    private update(current: Moment) {\n        this.$emit(\n            'input',\n            current.isValid() ? current.format('YYYY-MM-DD') : null\n        );\n    }\n\n    getDefault() {\n        if (!this.default) return null;\n        return moment(this.default).toDate();\n    }\n\n    getDate() {\n        if (!this.value) return null;\n        return moment(this.value).toDate();\n    }\n\n    getYear() {\n        if (!this.value) return null;\n        return moment(this.value).format('YYYY');\n    }\n    setYear(year: string) {\n        const current = moment(this.value || this.default || undefined);\n        current.set('year', parseInt(year));\n        this.update(current);\n    }\n    yearList() {\n        if (this.selectableDates) {\n            const years = this.selectableDates.map((date) =>\n                moment(date).year()\n            );\n            return [...new Set(years)];\n        }\n        const list = [];\n        const thisYear = moment().get('year');\n        for (let y = thisYear; y > thisYear - 120; y--) {\n            list.push(y);\n        }\n        return list;\n    }\n\n    getMonth() {\n        if (!this.value) return null;\n        return moment(this.value).format('MM');\n    }\n    setMonth(month: string) {\n        const current = moment(this.value || this.default || undefined);\n        current.set('month', parseInt(month) - 1);\n        this.update(current);\n    }\n    monthList() {\n        if (this.selectableDates && this.value) {\n            const year = moment(this.value).year();\n            const monthes = this.selectableDates\n                .map((date) => moment(date))\n                .filter((m) => m.year() == year)\n                .map((m) => m.month() + 1);\n            return [...new Set(monthes)].map((m) => ('0' + m).slice(-2));\n        }\n\n        const list = [];\n        for (let m = 1; m <= 12; m++) {\n            list.push(('0' + m).slice(-2));\n        }\n        return list;\n    }\n\n    getDay() {\n        if (!this.value) return null;\n        return moment(this.value).format('DD');\n    }\n    setDay(day: string) {\n        const current = moment(this.value || this.default || undefined);\n        current.set('date', parseInt(day));\n        this.update(current);\n    }\n    dayList() {\n        if (this.selectableDates && this.value) {\n            const year = moment(this.value).year();\n            const month = moment(this.value).month();\n            const days = this.selectableDates\n                .map((date) => moment(date))\n                .filter((m) => m.year() == year && m.month() == month)\n                .map((m) => m.date());\n            return [...new Set(days)].map((d) => ('0' + d).slice(-2));\n        }\n\n        const list = [];\n        const lastDay = moment(this.value || this.default || undefined)\n            .endOf('month')\n            .get('date');\n        for (let d = 1; d <= lastDay; d++) {\n            list.push(('0' + d).slice(-2));\n        }\n        return list;\n    }\n}\nexport default GuestDatePicker;\n</script>\n","div {\n  display: flex;\n  justify-content: start;\n  align-items: center;\n}\ndiv select {\n  cursor: pointer;\n  width: fit-content;\n  padding: 0 1.2em;\n}\n\n/*# sourceMappingURL=GuestDatePicker.vue.map */"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = "data-v-0addfa45"
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "script_src/common/GuestDatePicker.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__